import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SubDistrictDto } from '../../../../generated-model/models';
import { PageResponse } from '../../../shared/commons/page-response';

@Injectable({ providedIn: 'root' })
export class SubdistrictService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/master/subdistricts';

  getAllSubdistricts(page: number, size: number, search: string = "", state: number | null = null): Observable<PageResponse<SubDistrictDto>> { return this.http.get<PageResponse<SubDistrictDto>>(this.apiUrl + '?page=' + page + '&size=' + size + '&search=' + encodeURIComponent(search) + (state == null ? '' : '&state=' + state)); }
  getSubdistrictById(id: number): Observable<SubDistrictDto> { return this.http.get<SubDistrictDto>(`${this.apiUrl}/${id}`); }
  createSubdistrict(subdistrict: SubDistrictDto): Observable<SubDistrictDto> { return this.http.post<SubDistrictDto>(this.apiUrl, subdistrict); }
  updateSubdistrict(id: number, subdistrict: SubDistrictDto): Observable<SubDistrictDto> { return this.http.put<SubDistrictDto>(`${this.apiUrl}/${id}`, subdistrict); }
  deleteSubdistrict(id: number): Observable<void> { return this.http.delete<void>(`${this.apiUrl}/${id}`); }
}
